export default __webpack_public_path__ + "static/media/phone.a3924d67.png";